module.exports = __webpack_public_path__ + "img/noI_leaf_jade.7d1fbe2a.png";